import {UtilisateurModel} from './utilisateur.model';

export class SessionModel {

	id: number;
	utilisateur: UtilisateurModel;
	dateTime: string;
	userAgent: string;
	os: string;
	browser: string;
	device: string;
	osVersion: string;
	browserVersion: string;
	isDesktop: boolean;
	isMobile: boolean;
	isTablet: boolean;
	service: string;

}
